"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _SmtpToken = _interopRequireDefault(require("./SmtpToken"));

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSmtpTokensActionTypes.SUCCESS, function (state, action) {
  return state.withMutations(function (map) {
    action.payload.data.reduce(function (acc, item) {
      return acc.set(item.userName, new _SmtpToken.default(item));
    }, map);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateSmtpTokenActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.userName, new _SmtpToken.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.ResetSmtpTokenPasswordActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.userName, new _SmtpToken.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.DeleteSmtpTokenActionTypes.SUCCESS, function (state, action) {
  return state.remove(action.payload.props.userName);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;